import React from 'react';

import Autocomplete, {
  SuggestionArgs,
  RenderInputFn,
  RenderMenuArgs,
} from 'ha/ui/next/Autocomplete/Autocomplete';

import { MenuItem, Paper } from '@ha/dsl';

export interface SimpleItem {
  id: string;
  label: string;
  disabled?: boolean;
  placeId?: string;
}

// investigation needed for improving this functions using theme
// https://housinganywhere.atlassian.net/browse/HA-2573
export function renderSuggestion({
  item,
  highlighted,
  value,
}: SuggestionArgs<SimpleItem>) {
  const isSelected = value === item.label;

  return (
    <MenuItem
      key={item.id}
      selected={highlighted}
      disabled={item.disabled}
      component="div"
      style={{
        fontWeight: isSelected ? 500 : 400,
      }}
    >
      {item.label}
    </MenuItem>
  );
}

export function renderMenu({ menuItems }: RenderMenuArgs) {
  return (
    <Paper
      style={{ position: 'absolute', zIndex: 1, left: 0, right: 0 }}
      square
    >
      <div data-test-locator="Location - auto-suggest">{menuItems}</div>
    </Paper>
  );
}

export function getItemValue(item: SimpleItem) {
  return item.label;
}

interface RequiredProps {
  onChange: (value: string) => void;
  onSelect: (value: string, item: SimpleItem) => void;
  renderInput: RenderInputFn;
  items: SimpleItem[];
}

interface DefaultProps {
  value?: string;
}

type Props = RequiredProps & DefaultProps;

// This component is accepting a renderInput fn
// The main purpose of this component is to define a ui about
// how to render MENU for the particular managing of locations
// We accept a facc for the input because it usually needs to be controlled
// by something else, i.e: redux form field, formik, etc., which usually they
// need to pass specific props for errors, warnings, etc.
const LocationAutocompleteInput: React.FC<Props> = ({
  onChange,
  onSelect,
  items,
  renderInput,
  value = '',
}) => (
  <Autocomplete
    value={value}
    items={items}
    onChange={onChange}
    onSelect={onSelect}
    renderInput={renderInput}
    renderSuggestion={renderSuggestion}
    renderMenu={renderMenu}
    getItemValue={getItemValue}
    selectOnBlur={false}
  />
);

export default LocationAutocompleteInput;
